import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmAlert(props) {
    return <Dialog
        open={props.open}
        onClose={props.cancel}
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
    >
        <DialogTitle id="scroll-dialog-title">{props.language.instavc_confirmation}</DialogTitle>
        <DialogContent dividers={'paper'}>
            <DialogContentText>
                {props.content}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.cancel} color="primary">
                {props.language.Cancel}
            </Button>
            <Button onClick={props.ok} color="primary">
                {props.language.instavc_yes}
            </Button>
        </DialogActions>
    </Dialog>;
}